import dayjs from 'dayjs';
import { InitOptions } from 'i18next';
import translations from './i18n-data/panels-and-fasteners_en-GB.json';
import mockTranslations from './mocks/data/translation.json';

const resources = (useMockTranslations: boolean) => ({
  'en-GB': {
    'panels-and-fasteners': { ...(useMockTranslations ? mockTranslations : translations) },
  },
});

export default function getI18nConfig(useMockTranslations: boolean): InitOptions {
  return {
    resources: { ...resources(useMockTranslations) },
    debug: process.env.NODE_ENV === 'development',
    ns: 'panels-and-fasteners',
    fallbackLng: 'en-GB',
    load: 'currentOnly',
    interpolation: {
      format: function (value, format) {
        if (format === 'date') {
          return dayjs(value).format('ll');
        } else if (format === 'datetime') {
          return dayjs(value).format('lll');
        } else if (format === 'time') {
          return dayjs(value).format('LT');
        } else {
          return value;
        }
      },
    },
  };
}
